import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { FC } from 'react'

interface PageGuardKsProps extends React.HTMLAttributes<HTMLDivElement> {
  allowOtherRoles?: boolean
}

const PageGuardKs: FC<PageGuardKsProps> = ({
  children,
  allowOtherRoles = false,
}) => {
  const { isLoading: isLoadingRole, isKs, leave } = useRoleContext()

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoadingRole) return null

  if (!isKs && !allowOtherRoles) {
    leave()
    return null
  }

  return <>{children}</>
}

export default PageGuardKs
